

import { GamePlan } from '@/types/gamePlanner';
import { EditorHeader } from './components/EditorHeader';
import { NodeControls } from './components/NodeControls';
import { FlowEditor } from './components/FlowEditor';
import { SaveGamePlanDialog } from './SaveGamePlanDialog';
import { useFlowState } from './hooks/useFlowState';
import { usePlanSaving } from './hooks/usePlanSaving';

import '@xyflow/react/dist/style.css';
import './editor-flow.css';

interface GamePlanner2EditorProps {
  onCancel: () => void;
  onSaved?: () => void;
  currentPlan: GamePlan | null;
}

export function GamePlanner2Editor({ onCancel, onSaved, currentPlan }: GamePlanner2EditorProps) {
  const {
    nodes,
    edges,
    hasChanges,
    onNodesChange,
    onEdgesChange,
    onConnect,
    addNode
  } = useFlowState(currentPlan);

  const {
    showSaveDialog,
    isSaving,
    handleSaveClick,
    handleSaveCancel,
    handleSaveConfirm
  } = usePlanSaving({
    currentPlan,
    nodes,
    edges,
    onSaved
  });

  return (
    <div className="flex flex-col space-y-6">
      {/* Header with back button and save button */}
      <EditorHeader
        currentPlan={currentPlan}
        onCancel={onCancel}
        onSaveClick={handleSaveClick}
        isSaving={isSaving}
        hasUnsavedChanges={hasChanges}
      />
      
      {/* Flow editor controls */}
      <NodeControls onAddNode={addNode} />
      
      {/* Flow editor */}
      <FlowEditor 
        nodes={nodes} 
        edges={edges} 
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect} 
      />

      {/* Save dialog */}
      <SaveGamePlanDialog 
        open={showSaveDialog} 
        onCancel={handleSaveCancel} 
        onSave={handleSaveConfirm} 
        initialName={currentPlan?.is_template ? '' : currentPlan?.name || ''}
        initialDescription={currentPlan?.is_template ? '' : currentPlan?.description || ''}
        isTemplate={currentPlan?.is_template || false}
      />
    </div>
  );
}
